import * as React from "react";
import { useMemo } from "react";
import { useEventNotifications } from "components/event-notifications/hooks/useEventNotifications";
import NoAttributeProvided from "components/event-definitions/replay-search/NoAttributeProvided";
import useReplaySearchContext from "components/event-definitions/replay-search/hooks/useReplaySearchContext";
import EventNotificationLink from "components/event-notifications/event-notifications/EventNotificationLink";
import useAlertAndEventDefinitionData from "./hooks/useAlertAndEventDefinitionData";
const Notifications = () => {
  const { alertId, definitionId } = useReplaySearchContext();
  const { eventDefinition } = useAlertAndEventDefinitionData(alertId, definitionId);
  const { data: notificationsData } = useEventNotifications();
  const allNotifications = useMemo(
    () => {
      var _a;
      return Object.fromEntries(
        ((_a = notificationsData == null ? void 0 : notificationsData.notifications) != null ? _a : []).map((notification) => [notification.id, notification])
      );
    },
    [notificationsData]
  );
  const notificationList = useMemo(
    () => eventDefinition.notifications.flatMap(
      ({ notification_id }) => allNotifications[notification_id] ? [allNotifications[notification_id]] : []
    ),
    [allNotifications, eventDefinition.notifications]
  );
  return notificationList.length ? /* @__PURE__ */ React.createElement(React.Fragment, null, notificationList.map(({ id, title }, index) => {
    const prefix = index > 0 ? ", " : "";
    return /* @__PURE__ */ React.createElement("span", { key: id }, prefix, /* @__PURE__ */ React.createElement(EventNotificationLink, { id, title }));
  })) : /* @__PURE__ */ React.createElement(NoAttributeProvided, null);
};
export default Notifications;
